import { IsBlockedInterface } from "module/block/types";
import {
  ApiCertificationInterface,
  ApiCertificationSessionInterface,
} from "api/competencyManagement/types";
import {
  AbstractMyEntityInterface,
  EntityChangedDate,
  EntityIdentifier,
  EntityWithId,
  EntityWithRelationships,
} from "module/entity/types";

export interface CertificationIsBlockedInterface extends IsBlockedInterface {
  isBlockedBecauseItIsCompleted: boolean;
  isBlockedBecauseUserHasNoPermissions: boolean;
}

export interface CertificationSessionInterface
  extends EntityWithId,
    EntityWithRelationships,
    EntityChangedDate {
  certificationId: string;
  name: string;
  remarks: string;
  completeDate?: string;
  achieved: boolean;
  isCategory: boolean;
  level: number;
  sorting: number;
}

export type MyCertificationSessionInterface = AbstractMyEntityInterface<
  ApiCertificationSessionInterface,
  CertificationSessionInterface
>;

export enum CertificationState {
  initScheduled = "init_sched",
  scheduled = "scheduled",
  completed = "completed",
}

export interface CertificationInterface
  extends EntityWithId,
    EntityWithRelationships,
    EntityChangedDate {
  name: string;
  reportingNumber?: string;
  remarks: string;
  assigneeId?: number;
  internalCertifierId?: number;
  externalCertifier?: string;
  scheduledDate: string;
  scheduledStartDate: string;
  scheduledEndDate: string;
  state: CertificationState;
  moduleText: string;
  expectedDate: string;
  completionStartDate?: string;
  completionEndDate?: string;
  isBlockedDetails: CertificationIsBlockedInterface;
  sessions: EntityIdentifier[];
}

export type MyCertificationInterface = AbstractMyEntityInterface<
  ApiCertificationInterface,
  CertificationInterface
>;
